import { STYLE_OPTIONS } from 'src/constants';

const fontWeight = 400;

const buttonBoxStyle = () => ({
  // The two header icons (video, share) sit on ONE row, right-aligned and
  // centered on each other. Without an explicit direction the Grid wraps
  // when the header is narrow, which stacked the share icon under the video
  // one; nowrap keeps them side by side at every width.
  rootBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  buttonEdit: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY,
    fontWeight,

    '& .MuiSvgIcon-root': {
      marginRight: 8,
    },
  },

  // No paddingTop override: it lifted the video icon above the share icon's
  // centerline. Both now inherit IconButton's own padding so they align.
  buttonVideo: {}
});

export default buttonBoxStyle;
